document.addEventListener("DOMContentLoaded", () => {
  // document.querySelectorAll(".first-level-dropdown").forEach((item) => {
  //   $(item).hover(
  //     function () {
  //       $(this).find(".another-dropdown").css("pointer-events", "auto");
  //     },
  //     function () {
  //       $(this).find(".another-dropdown").css("pointer-events", "none");
  //     }
  //   );
  // });

  //hero button redirect to homepage collection
  const btn_hero = $(".homepage-section-btn-container > a");
  const collection_homepage = $(".featured-collections-wrapper");
  if ($(btn_hero).length) {
    $(btn_hero).attr("href", "#collections");
    $(btn_hero).on("click", function (e) {
      e.preventDefault();
      if($(collection_homepage).length){
         $("html, body").animate(
           { scrollTop: collection_homepage.offset().top - 100 },
           800
         );
      }
    });
  }

  if ($("#AccessibleNav > .site-nav--has-dropdown").length > 0) {
    // alert("working dropdown");
    $("#AccessibleNav > .site-nav--has-dropdown").on("click", function (e) {
      if ($(e.target).closest("a").parent().is(this)) {
        e.preventDefault();
        e.stopPropagation();

        const isShown = $(this).hasClass("is-shown");
        $("#AccessibleNav > .site-nav--has-dropdown").removeClass("is-shown");

        if (!isShown) {
          $(this).addClass("is-shown");
        }
      }
    });
  } else {
    alert("not working...");
  }

  // Optional: Close dropdown if clicking outside
  $(document).on("click", function () {
    $(".another-dropdown").css("pointer-events", "none");
  });

  //toggle user login options
  if ($("#show-login-option").length) {
    $("#show-login-option").on("click", function (e) {
      e.preventDefault();
      $(".user-login-options").toggleClass("is-shown");
    });
  }

  //toggle product info section
  if ($(".product-info-section").length) {
    $(".product-info-section .tab li > button ").on("click", function () {
      $(".product-info-section .tab__content .tab-box").removeClass("is-shown"); //remove all is-shown class
      $(".product-info-section .tab li > button").removeClass("is-active");

      const dataAttr = $(this).attr("data-tab");
      $(`#${dataAttr}`).addClass("is-shown");
      $(this).addClass("is-active");
    });
  }

  // make collection list on homepage sliding
  $(
    ".homepage-wrapper .featured-collections-wrapper .collection-grid style"
  ).remove();
  $(".homepage-wrapper .featured-collections-wrapper .collection-grid").slick({
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    responsive: [
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 550,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  });

  //change url of about us navigation banner
  $("#about .navigation-banner a").each((index, item) => {
    const text = $(item).text().trim();
    const sectionMap = {
      "how-it-works": 4,
      financing: 7,
      "our-team": 8,
      "sapphire-club": 9,
    };
    const splittedTextAttr = text
      .split(" ")
      .map((item) => item.toLowerCase())
      .join("-");
    $(item).attr("data-section-id", splittedTextAttr);

    if (sectionMap[splittedTextAttr]) {
      $(item).on("click", (e) => {
        e.preventDefault();
        const targetSection = $(
          `.shopify-section:nth-of-type(${sectionMap[splittedTextAttr]})`
        );
        if (targetSection.length) {
          $("html, body").animate(
            { scrollTop: targetSection.offset().top - 100 },
            800
          );
        } else {
          console.log("Target section not found");
        }
      });
    }
  });

  //detect if there's a hash in url in about us
  const aboutUsPage = document.querySelector("#about");
  if (aboutUsPage) {
    const hash = window.location.hash;
    if (hash) {
      if (hash == "#financing") {
        const targetSection = aboutUsPage.querySelector(
          ".shopify-section:nth-of-type(7)"
        );
        targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
      } else if (hash == "#how-it-works") {
        const targetSection = aboutUsPage.querySelector(
          ".shopify-section:nth-of-type(4)"
        );
        targetSection.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }

  //custom navigation for collection page
  const isCollection = document.querySelector(".template-collection");
  if (isCollection) {
    const collectionName = window.ShopifyData.collectionTitle.trim();
    const customNavNames = ["Chairs", "Accent Tables", "Sectionals", "Bedroom"];
    const customNavs = {
      Chairs: [
        { name: "Desk Chairs", url: "/collections/desk-chairs" },
        { name: "Desks", url: "/collections/desks" },
        { name: "Accent Chairs", url: "/collections/kitchen-dining-25" },
        { name: "Office Storage", url: "/collections/office-storage" },
      ],
      Bedroom: [
        { name: "Owner's Suite", url: "/collections/owners-suite" },
        { name: "Secondary Bedroom", url: "/collections/secondary-bedrooms" },
        { name: "Flex", url: "/collections/flex-room" },
        { name: "Loft", url: "/collections/loft" },
        { name: "Recreation Room", url: "/collections/recreation-rooms" },
      ],
      Sectionals: [
        { name: "Sofas", url: "/collections/sofas-sectionals-1" },
        { name: "Sectionals", url: "/collections/sectionals" },
        { name: "Sleepers", url: "/collections/sleepers" },
      ],
      "Accent Tables": [
        { name: "Coffee & Cocktail", url: "/collections/kitchen-dining-24" },
        { name: "Consoles", url: "/collections/consoles-credenzas" },
        { name: "Ottomans & Stools", url: "/collections/ottomans-stools-1" },
        { name: "Accent Tables", url: "/collections/accent-tables-1" },
      ],
    };

    if (customNavNames.includes(collectionName)) {
      let customNavHTML = "";
      if (customNavs[collectionName]) {
        customNavHTML = `
          <ul class="custom-navigation">
            ${customNavs[collectionName]
              .map(
                (item) =>
                  `<li><a href="${item.url}"><span>${item.name}</span></a></li>`
              )
              .join("")}
          </ul>
        `;
      }
      $(customNavHTML).insertAfter(".section--collection-header");
    } else {
      const headerNav = $(
        `header #top_links_wrapper .site-nav a span:contains('${collectionName}')`
      ).filter(function () {
        return (
          $(this).text().trim().toLowerCase() === collectionName.toLowerCase()
        );
      });
      // console.log(headerNav)
      console.log(collectionName);

      if (headerNav.length) {
        const mainCategoryLi = headerNav.closest("li.first-level-dropdown"); // get the parent LI
        console.log(mainCategoryLi);

        const clonedUl = mainCategoryLi
          .children("ul.site-nav__dropdown")
          .clone(); // clone submenu dropdown
        console.log(clonedUl);
        clonedUl.find("ul.site-nav__subdropdown, svg").remove();

        const cleanedHTML = clonedUl
          .clone()
          .find("*")
          .removeAttr("class style aria-haspopup data-logo-placement")
          .end()
          .removeAttr("class style aria-haspopup data-logo-placement")
          .addClass("custom-navigation")
          .prop("outerHTML");
        $(cleanedHTML).insertAfter(".section--collection-header");
      } else {
        console.log("cannot found the nav");
      }
    }
  }

  //open hubspot chat
  const openChatBtn = document.querySelector("#open-hubspot-chat");
  if (openChatBtn) {
    openChatBtn.addEventListener("click", function (e) {
      e.preventDefault();
      if (window.HubSpotConversations && window.HubSpotConversations.widget) {
        window.HubSpotConversations.widget.open();
      } else {
        console.log("not loaded");
      }
    });
  }
  // change button text of custom newsletter
  const custom_newsletter = $(".custom-newsletter");
  const observer = new MutationObserver((mutationList, observer) => {
    mutationList.forEach((mutation) => {
      const btn_newsletter = $(
        ".custom-newsletter .hbspt-form input[type='submit']"
      );
      if (btn_newsletter.length) {
        btn_newsletter.prop("value", "Sign Up");
        observer.disconnect();
      } else {
        console.log("no form input has been found");
      }
    });
  });

  observer.observe(custom_newsletter[0], {
    childList: true,
    subtree: true,
  });
});
